import React from 'react';
import { HashLink } from 'react-router-hash-link';

const ServicesSection = ({ services }) => {
  return (
    <div
      className="bg-gray-100 py-4 px-4 md:px-8 lg:px-20 text-center flex flex-col items-center"
      data-aos="fade-up"
    >
      <h2
        className="text-3xl md:text-4xl font-bold text-[#2584C6]"
        data-aos="fade-down"
        data-aos-duration="800"
      >
        Our Services
      </h2>

      <h1
        className="text-[#F7941D] text-2xl md:text-3xl mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        We always offer the best services for success!
      </h1>

      <p
        className="text-gray-600 max-w-3xl mx-auto text-lg mt-3"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        We create customized software that is tailored to your specific needs, budget and timeline.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-20 mb-20">
      {services.map((service, index) => (
  <div
    key={service.id}
    data-aos="fade-up-right"
    data-aos-delay={index * 100}
    className="w-full"
  >
    
    <div className="transition-transform duration-300 md:hover:scale-105 will-change-transform">
      <div className="rounded-lg shadow-md bg-white relative overflow-visible h-[250px] md:h-[350px] lg:h-[300px] flex flex-col">
        <div className="bg-[#F7941D] pt-10 pb-4 text-white rounded-md">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md border-2 border-[#2584C6]">
            <img src={service.image} alt={service.title} className="w-6 h-6" />
          </div>
          <h3 className="text-lg font-semibold">{service.title}</h3>
        </div>

        <div className="px-4 py-4 flex flex-col flex-grow">
          <p className="text-gray-600 text-sm mb-4 lg:text-md xl:text-lg">
            {service.description}
          </p>
          <div className="mt-auto">
            <HashLink
              to={`/services/#${service.id}`}
              smooth
              className="text-sm font-semibold text-black underline"
            >
              MORE
            </HashLink>
          </div>
        </div>
      </div>
    </div>
  </div>
))}

      </div>
    </div>
  );
};

export default ServicesSection;
